<template>
  <div class="tooltip-container">
    <div v-show="showInfo" class="hover-info">{{ text }}</div>
    <span @mouseover="showInfo = true" @mouseout="showInfo = false">
      <font-awesome-icon class="i-icon" :icon="['fas', 'square-info']" />
    </span>
  </div>
</template>

<script>
export default {
  name: "HoverToolTip",
  props: {
    text: String,
  },
  data() {
    return {
      showInfo: false,
    }
  }
};
</script>

<style scoped>
  .tooltip-container {
    position: relative;
    min-width: 200px;
    display: flex; 
    justify-content: end;
  }
  .hover-info {
    position: absolute;
    min-width: 200px; 
    min-height: 100px; 
    bottom: 20px; 
    background-color: rgb(35, 35, 35);
    border-radius: 20px;
    color: white;
    text-align: left;
    font-weight: 400;
    padding: 15px;
  }
  .i-icon {
    font-size: 19px;
  }
</style>